import axios from '@/axios.js'

export default {
    getContactPhones: async (appUuid) => {
        try {
            const response = await axios.editorapi.get(`contact-phones/v3/apps/${appUuid}`)
            return response.data.object
        } catch (error) {
            throw new Error(error)
        }
    },
    getContactPhoneTypes: async () => {
        try {
            const response = await axios.editorapi.get(`contact-phones/v3/types`)
            return response.data.object
        } catch (error) {
            throw new Error(error)
        }
    },
    createContactPhone: async (appUuid, payload) => {
        try {
            const response = await axios.editorapi.post(`contact-phones/v3/apps/${appUuid}`, payload)
            return response.data
        } catch (error) {
            throw new Error(error)
        } 
    },
    saveContactPhone: async (appUuid, contactphoneUuid, payload) => {
        try {
            const response = await axios.editorapi.patch(`contact-phones/v3/apps/${appUuid}/${contactphoneUuid}`, payload)
            return response.data
        } catch (error) {
            throw new Error(error)
        } 
    },
    deleteContactPhone: async (appUuid, contactphoneUuid) => {
        try {
            const response = await axios.editorapi.delete(`contact-phones/v3/apps/${appUuid}/${contactphoneUuid}`)
            return response.data
        } catch (error) {
            throw new Error(error)
        } 
    },
    sortContactPhones: async (appUuid, contactPhonesOrdered) => {
        try {
            const response = await axios.editorapi.patch(`contact-phones/v3/apps/${appUuid}`, { 'sorted_contact_phones': contactPhonesOrdered })
            return response.data
        } catch (error) {
            throw new Error(error)
        }
    }
}